import {
  PaidInvoicesSuccess,
  OrderCanceled,
  OrderSubmitted,
  FlashSaleOrderSubmitted,
  LimitIncreaseApplicationSubmitted,
} from "@faire/deprecated-retailer-visitor-shared/events";
import { useIsBrandPreview } from "@faire/deprecated-retailer-visitor-shared/lib/getIsBrandPreview";
import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";
import { useQuery as useRetailerCreditSummaryQuery } from "@faire/web-api--source/endpoints/www/api/retailer/retailerToken/credit-summary/get-hooks";
import { IRetailerCreditSummary } from "@faire/web-api--source/indigofair/data/IRetailerCreditSummary";
import { useEffect, useMemo } from "react";

export const useCreditSummary = () => {
  const retailerToken = getRetailer()?.token;
  const isBrandPreview = useIsBrandPreview();
  const {
    refetch,
    data: creditSummary,
    ...retailerCreditSummaryResults
  } = useRetailerCreditSummaryQuery(retailerToken ?? "", {
    enabled: !!retailerToken && !isBrandPreview,
  });

  useEffect(() => {
    PaidInvoicesSuccess.subscribe(() => refetch());
    OrderCanceled.subscribe(() => refetch());
    OrderSubmitted.subscribe(() => refetch());
    FlashSaleOrderSubmitted.subscribe(() => refetch());
    LimitIncreaseApplicationSubmitted.subscribe(() => refetch());
  }, [refetch]);

  const isLimitIncreaseEligible = useMemo(() => {
    return (
      creditSummary?.limit_increase?.status ===
      IRetailerCreditSummary.LimitIncreaseStatus.ELIGIBLE
    );
  }, [creditSummary]);

  return {
    ...retailerCreditSummaryResults,
    creditSummary,
    refetch,
    isLimitIncreaseEligible,
  };
};
